import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { IndustryDetail } from '@src/pages/Industries';

export const Route = createLazyFileRoute('/industries/government')({
  component: GovernmentIndustryPage,
});

function GovernmentIndustryPage() {
  return (
    <DefaultLayout>
      <IndustryDetail industryId="government" />
    </DefaultLayout>
  );
}
